import { render, staticRenderFns } from "./InputTextarea.vue?vue&type=template&id=b563064e&scoped=true&"
import script from "./InputTextarea.vue?vue&type=script&lang=ts&"
export * from "./InputTextarea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b563064e",
  null
  
)

export default component.exports